'use strict';
import React from 'react';
import PropTypes from 'prop-types';

const Table = (props) => {
    const {
        headers,
        headerSizes,
        maxHeight,
        children,
        type,
        style,
        onClickHeader,
        sortableColumns
    } = props;

    const isFixed = maxHeight !== 0;

    const tableWrapperStyle = {
        height: maxHeight,
        position: 'relative',
        overflow: 'visible',
        marginBottom: '60px',
        borderLeft: '0',
        borderTop: '0',
        borderRight: '0'
    };

    const tableContainerStyle = {
        height: '100%',
        overflowY: 'auto'
    };

    const thInnerStyle = {
        position: 'absolute',
        display: 'block',
        top: 0
    };

    const headerBackgroundStyle = {
        backgroundColor: '#f9f9f9',
        height: '60px'
    };

	function handleOnClickHeader(index) {
        if(sortableColumns.indexOf(index) >= 0)
        {
            return function (event) {
                onClickHeader(index, event);
            };
        }
        else
        {
            return null;
        }
	}

    if (isFixed)
        return (<div className="c-table-wrapper" style={tableWrapperStyle}>
            <div className="c-table__spacer" style={headerBackgroundStyle}></div>
            <div className="c-table__container" style={tableContainerStyle}>
                <table className={"c-table  c-table--scrollable"} style={{ position: 'static' }}>
                    {headers ? <thead>
                        <tr>
                            {headers.map((header, i) => {
                                return headerSizes.length > 0 ?
                                    (<th onClick={handleOnClickHeader(i)} key={i} width={headerSizes[i] + '%'}><span style={thInnerStyle}>{header} {sortableColumns.indexOf(i) >= 0 ?<i className="fa fa-sort fa-fw" /> : null}</span></th>) :
                                    (<th onClick={handleOnClickHeader(i)} key={i}><span style={thInnerStyle}>{header} {sortableColumns.indexOf(i) >= 0 ?<i className="fa fa-sort fa-fw" /> : null}</span></th>);
                            })}
                        </tr>
                    </thead> : null}
                    <tbody>
                        {children}
                    </tbody>
                </table>
            </div>
        </div>);

    return (
        <table className={"c-table " + type} style={style}>
            {headers ? <thead>
                <tr>
                    {headers.map((header, i) => {
                        return headerSizes.length > 0 ?
                            (<th onClick={handleOnClickHeader(i)} key={i} width={headerSizes[i] + '%'}>{header} {sortableColumns.indexOf(i) >= 0 ?<i className="fa fa-sort fa-fw" /> : null}</th>) :
                            (<th onClick={handleOnClickHeader(i)} key={i}>{header} {sortableColumns.indexOf(i) >= 0 ?<i className="fa fa-sort fa-fw" /> : null}</th>);
                    })}
                </tr>
            </thead> : null}
            <tbody>
                {children}
            </tbody>
        </table>
    );
};

Table.defaultProps = {
    type: 'regular',
    headers: [],
    headerSizes: [],
    maxHeight: 0
};

Table.propTypes = {
    headers: PropTypes.array,
    headerSizes: PropTypes.array,
    type: PropTypes.string,
    maxHeight: PropTypes.number,
    children: PropTypes.node,
    style: PropTypes.object,
    onClickHeader: PropTypes.func,
    sortableColumns: PropTypes.array
};

export default Table;